import { ENRICHMENT_ANSWER_TYPE_NUMBER } from "../enrichmentAnswerTypes";

export function isEnrichmentAnswerTypeNumber(enrichment) {
    return enrichment.answer_type == ENRICHMENT_ANSWER_TYPE_NUMBER;
}
